import angular from 'angular';
import DefaultGrouping from './default';

class TitleGrouping extends DefaultGrouping {
	constructor() {
		super();

		this.groupByPulldown = false;
		this.key = 'title';
		this.displayName = 'Title';
		this.secondarySortable = true;

		this.getDocDisplayText = super.getDisplayText;
		this.getSortingValue = super.getDisplayText;
		this.getMemoText = super.getDisplayText;
		this.getHeaderDisplayName = super.getDisplayName;
	}

}

export default angular.module('groupings.title-grouping', [])
	.service('TitleGrouping', TitleGrouping)
	.name;



// WEBPACK FOOTER //
// ./project/groupings/title.js